<table
	mat-table
	aria-describedby="table-component"
	[dataSource]="dataSource"
	class="mat-elevation-z8"
>
	<ng-container
		*ngFor="let header of headersToDisplay"
		[matColumnDef]="header.property ?? ''"
	>
		<th mat-header-cell mat-sort-header *matHeaderCellDef>
			{{ header.description }}
		</th>
		<div>
			<td mat-cell *matCellDef="let element" [formGroup]="element">
				<container-element [ngSwitch]="header.formType">
					<!-- the same view can be shown in more than one case -->
					<mat-form-field *ngSwitchCase="formTableType.DateTime">
						<input
							matInput
							[matDatepicker]="picker"
							[formControlName]="header.property ?? ''"
						/>
						<mat-datepicker-toggle
							matIconSuffix
							[for]="picker"
						></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
					</mat-form-field>

					<!--default case when there are no matches -->
					<mat-form-field *ngSwitchDefault
						><input
							matInput
							[formControlName]="header.property ?? ''"
							required
					/></mat-form-field>
				</container-element>
			</td>
		</div>
	</ng-container>
	<ng-container *ngIf="showActions" matColumnDef="action">
		<th mat-header-cell *matHeaderCellDef>Action</th>

		<td mat-cell *matCellDef="let element; let i = index">
			<button mat-button [matMenuTriggerFor]="menu">
				<mat-icon>more_vert</mat-icon>
			</button>

			<mat-menu #menu="matMenu">
				@for (action of actions; track action.eventName) {
				<button
					mat-menu-item
					(click)="actionClicked(action, element, i)"
				>
					<mat-icon>{{ action.icon }}</mat-icon>

					<span>{{ action.description }}</span>
				</button>
				}
			</mat-menu>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
